/**
 * Hook to access the Google Calendar context.
 */
import { useContext } from 'react';
import { GCalContext } from './GCalContext.def';

/**
 * Accesses the Google Calendar integration state and actions.
 * @returns {import('./GCalContext.def').GCalContextValue}
 */
export const useGCal = () => {
  const context = useContext(GCalContext);
  if (!context) {
    throw new Error('useGCal must be used within a GCalProvider');
  }
  return context;
};
